import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'co',
    fullName: 'Corsican',
    nativeName: 'Corsican',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Qualcosa di maravigghiusu vene",
    landing_subtitle: "ArgVoid hè un studiu di sviluppu di app è ghjoculi. Stammi sintonizzati, e cose novi venenu prestu !",
    select_language: "Selezziunà a lingua",
    search_placeholder: "Ricerca lingue...",
    terms_title: "Termini di serviziu",
    policy_title: "Pulitica di privacy",
    cookies_title: "Pulitica di Cookie",
    terms_content: `
        <strong>1. Accettazione di i Termini</strong><br>
        Accedendu à ArgVoid, sti Termini di serviziu sò accettati. Sì sti termini ùn sò micca accunsentutu, u serviziu ùn deve esse usatu.<br><br>

        <strong>2. Utilizà a piattaforma </strong><br>
        ArgVoid è e so applicazioni sò furnite "cum'è" per scopi informativi è creativi. U serviziu deve esse usatu solu per scopi legali.<br><br>

        <strong>3. Cunducta pruibita</strong><br>
        Sfruttà e vulnerabilità di u situ, spamming, o tentativu di accessu micca autorizatu à l'infrastruttura hè strettamente pruibitu.<br><br>

        <strong>4. Disclaimer</strong><br>
        A piattaforma è i servizii ponu esse mudificate in ogni mumentu senza avvisu. Nisuna garanzia hè furnita in quantu à u uptime o a dispunibilità di u serviziu.
    `,
    policy_content: `
        <strong>1. Raccolta di informazioni</strong><br>
        A piattaforma ùn hà micca bisognu di l'autentificazione di l'utilizatori o a creazione di un contu in questu mumentu. Nisuna infurmazione d'identità persunale (cum'è nomi o indirizzi email) hè attivamente recullata da i visitori.<br><br>

        <strong>2. Dati d'usu </strong><br>
        L'analitiche basiche, anonimizate ponu esse cullucate per capisce u trafficu di u situ è migliurà l'applicazioni. Questa data ùn hè micca ligata à l'identità di l'utilizatori individuale.<br><br>

        <strong>3. Servizi di terze parti</strong><br>
        I fornitori di terzu pò esse aduprati per i servizii di hosting è di analisi. E pratiche di privacy di sti fornituri rispettivi guvernanu i dati anonimi trattati nantu à a so infrastruttura.<br><br>

        <strong>4. Sicurezza di Dati</strong><br>
        E misure di sicurezza ragiunate sò implementate per prutege a piattaforma. Tuttavia, nisun metudu di trasmissione in Internet hè cumplettamente sicuru.<br><br>
    `,
    cookies_content: `
        <strong>1. Chì sò i Cookies è u Storage Local ?</strong><br>
        I cookies è l'almacenamiento lucale di u navigatore sò picculi schedarii di dati almacenati in u dispositivu per ricurdà e preferenze di cunfigurazione in tutte e visite.<br><br>

        <strong>2. Scopu d'usu</strong><br>
        Browser LocalStorage hè aduprata strettamente per salvà i paràmetri di cunfigurazione, cum'è: <br>
        - Preferenze di lingua <br>
        - Cunfigurazione di l'interfaccia d'utilizatore (per esempiu, paràmetri di layout o tema) <br>
        - Cache di l'applicazione temporanea<br><br>

        <strong>3. Nisun Tracking</strong><br>
        I cookies è l'almacenamiento lucale ùn sò micca usati per publicità o scopi di seguimentu di terzu. Tutti i dati almacenati sò strettamente per a funziunalità core di a piattaforma.<br><br>

        <strong>4. Control</strong><br>
        I dati di u navigatore ponu esse sbulicati in ogni mumentu per mezu di i paràmetri di u navigatore, chì resettanu ogni cunfigurazione lucale.
    `,
    cookie_consent_text: "Utilizemu i cookies basi per assicurà chì u situ web funziona bè, cum'è mantene a vostra sessione attiva, salvà a vostra preferenza di lingua è altre cunfigurazioni persunalizate.",
    read_policy: "Leghjite a Politica di Cookie",
    support_title: "Cuntattate u Supportu",
    support_subject_label: "Sugettu",
    support_message_label: "Missaghju",
    support_submit_button: "Mandate Missaghju",
    support_hint: "Nota: Questu apre a vostra applicazione email predeterminata per mandà u messagiu.",
    support_success_msg: "Apertura a vostra app di e-mail...",
    support_error_msg: "Impossible di mandà u missaghju. Per piacè pruvate di novu più tardi.",
    explorer_title: "Explorer",
    history_title: "Storia",
    animation_title: "Animazione",
    config_title: "Cunfigurazione",
    tool_mouse: "Selezziunà (Ctrl+M)",
    tool_brush: "Pennello (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Solidu/Clear)",
    tool_eraser: "Gomme (Ctrl+E)",
    tool_brush_size: "Aghjustate a dimensione di a spazzola",
    tool_bucket: "Riempi (Ctrl+F)",
    tool_eyedropper: "Contagocce",
    tool_grid: "Griglia (Ctrl+Maiusc+B)",
    tool_rotate: "Gira (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Maiusc+H)",
    tool_flip_v: "Flip V (Ctrl+Maiusc+V)",
    tool_transpose: "Trasposizione (Ctrl+Maiusc+T)",
    label_width: "Larghezza",
    label_height: "Altezza",
    label_frames: "Numero di Frames",
    label_animation: "Stile d'animazione",
    label_background_color: "Culore di fondu",
    label_interval: "Intervallu",
    tool_anim_config: "Configurazione di l'animazione",
    label_new_width: "New Wirth",
    label_new_height: "Nova Altezza",
    label_apply: "Applica",
    label_colors: "Culori",
    label_size: "Taglia",
    label_tolerance: "Tolleranza",
    val_horizontal: "Orizzontale",
    val_vertical: "Verticale",
    val_sequence: "Sequenza",
    val_bounce: "Bounce",
    val_random: "casuale",
    val_solid: "Solidu",
    val_clear: "Chjara",
    action_add_sheet: "New Sheet",
    action_import: "Importà",
    action_export: "Esporta",
    action_sort_projects: "Sorte",
    sort_date_old: "U più anticu prima",
    sort_date_new: "U più novu prima",
    sort_name_az: "Nome (A-Z)",
    sort_name_za: "Nome (Z-A)",
    action_new_sprite: "Novu Sprite",
    action_new_project: "Prughjettu novu",
    modal_save_all_title: "Salvà tutti i cambiamenti",
    modal_save_all_desc: "Selezziunate l'assi da salvà:",
    modal_save_selected: "Salvà Scelti",
    action_saved: "Salvatu",
    modal_create_sprite_title: "Crea un novu Sprite",
    modal_create_project_title: "Crea un novu prughjettu",
    modal_add_sheet_title: "Add New Sheet",
    modal_rename_sheet_title: "Rename Sheet",
    modal_rename_sprite_title: "Rinominate Sprite",
    modal_delete_sprite_title: "Elimina Sprite",
    modal_delete_project_title: "Sguassà u prughjettu",
    modal_delete_sheet_title: "Sguassà u fogliu",
    placeholder_sprite_name: "Nome",
    placeholder_project_name: "Nome",
    placeholder_sheet_name: "Nome",
    placeholder_new_name: "New Name",
    action_create: "Crià",
    action_add: "Add",
    action_rename: "Rinomina",
    action_duplicate: "Duplicate",
    action_delete: "Sguassà",
    action_cancel: "Cancella",
    confirm_delete_sprite: "Sò sicuru chì vulete sguassà stu sprite ?",
    confirm_delete_project: "Sò sicuru chì vulete sguassà stu prughjettu ? Tutti i sprites seranu eliminati.",
    confirm_delete_sheet: "Sò sicuru chì vulete sguassà stu fogliu ?",
    err_select_sprite: "Per piacè selezziunate un sprite prima.",
    err_select_project: "Per piacè selezziunate un prughjettu prima.",
    err_name_empty: "U nome ùn pò esse viotu.",
    err_sprite_exists: "Un sprite cù quellu nome esiste digià.",
    err_project_exists: "Un prughjettu cù questu nome esiste digià.",
    err_no_content: "Nisun cuntenutu per salvà.",
    err_no_changes: "Nisun cambiamentu per salvà.",
    err_delete_last_sheet: "Ùn pò micca sguassà l'ultimu fogliu.",
    err_extract_frames: "Ùn pudia micca estrazione alcuna frames.",
    err_indexeddb: "Impossible di salvà in u locu. U vostru navigatore ùn pò micca sustene IndexedDB.",
    msg_upload_success: "Caricà successu: {0}",
    msg_upload_failed: "Caricà fallutu: {0}",
    msg_save_success: "Salvà successu.",
    msg_saving: "Salvà...",
    msg_multi_save_result: "Salvatu {0} assi. {1} fallimenti.",
    menu_title: "Menu",
    menu_save: "Salvà",
    menu_save_all: "Salvà tuttu",
    menu_support: "Cuntattate u Supportu",
    label_local_storage: "Storage Locale",
    label_sign_in: "Firmà lu",
    modal_export_title: "Esporta Sprite",
    label_filename: "Filename",
    label_format: "Format",
    action_export_confirm: "Esporta",
};

export default translations;
